import moment from 'moment';

export class Message {
  constructor(data) {
    var self = this;
    self.type = "Message";

    self.rootvm = data.rootvm;

    self.parent_event = data.parent_event;

    self.event_uuid = ko.observable(data.event_uuid);
    self.message_uuid = data.message_uuid;
    self.message = ko.observable(data.message);
    self.inserted = ko.observable(new moment(data.inserted));

    self.pretty_inserted_calendar = ko.computed(function () {
      return self.inserted().calendar();
    });

    self.actor = ko.observable(data.actor);

    self.filter_needed = ko.observable(data.filter_needed);
    self.filter_positions = data.filter_positions;
    self.length_filter_string = data.length_filter_string;
    self.filtered_message = ko.observable(data.filtered_message);

    self.filters = ko.observableArray(data.filters || []);

    self.sender_pretty_name = ko.observable(data.sender_pretty_name);

    self.message_read = ko.observable(data.message_read);

    self.sender_uuid = ko.observable(data.sender_uuid);
    self.receiver_uuid = ko.observable(data.receiver_uuid);

    self.attachments = ko.observableArray(data.attachments);

    self.message_with_filter_link = ko.pureComputed(function () {
      var filter =
        ' <span class="label label-btn" data-toggle="popover" tabindex="0" style="display:inline" data-bind="popover:function(){return $(\'#popover-contact-details\').html()},';
      filter +=
        "popoverTitle:function(){return i18nextko.i18n.translator.translate('manage_concerts.infobox.contact.popover.title')}\" ";
      filter +=
        'data-html="true" data-trigger="focus" data-original-title="" title=""> ';
      filter += '<span class="mdi mdi-phone-in-talk"></span></span> ';

      if (self.filter_needed()) {
        var message = self.message();
        // test double with f7bec54d-c60d-4512-a9cd-ee7b555f56e5
        for (var i = self.filter_positions.length - 1; i >= 0; i--) {
          message =
            message.substring(0, self.filter_positions[i] - 1) +
            filter +
            message.substring(
              self.filter_positions[i] + self.length_filter_string - 1,
              message.length
            );
        }
        return message;
      } else {
        return self.message();
      }
    });

    self.reported = ko.observable(false);
    self.report_no_filter = async function () {
      self.reported(true);
      const url = scvm.web_host + "/api/admin/message/report-no-filter";
      const request = new Request(url, {
        body: ko.toJSON({
          message_uuid: self.message_uuid,
        }),
        processData: false,
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });
      const response = await fetch(request);
      const data = await response.json();
      console.log(data);
      if (data.success) {
        self.filter_needed(false);
        self.filtered_message(null);
        self.filters([]);
        self.parent_event.filter_needed(
          self.parent_event.messages().some((m) => m.filtered_message())
        );
      } else {
        self.reported(false);
        throw new Error(data.message);
      }
    };
  }
}

export class UnreadMsgCount {
  constructor(rootvm, actor, data) {
    var self = this;
    self.type = "UnreadMsgCount";

    self.rootvm = rootvm;
    self.actor = actor;

    self.upcoming = ko.observable(data.upcoming || null);
    self.upcoming.subscribe(function (newValue) {
      if (newValue == 0) self.upcoming(null);
    });
    self.passed = ko.observable(data.passed || null);
    self.passed.subscribe(function (newValue) {
      if (newValue == 0) self.passed(null);
    });
    self.cancelled = ko.observable(data.cancelled || null);
    self.cancelled.subscribe(function (newValue) {
      if (newValue == 0) self.cancelled(null);
    });
    self.open = ko.observable(data.open || null);
    self.open.subscribe(function (newValue) {
      if (newValue == 0) self.open(null);
    });
    self.total = ko.pureComputed(function () {
      val = self.open() + self.cancelled() + self.passed() + self.upcoming();
      return val === 0 ? null : val;
    }, self);
    self.requests = ko.pureComputed(function () {
      val = self.open() + self.cancelled();
      return val === 0 ? null : val;
    }, self);
    self.events = ko.pureComputed(function () {
      val = self.passed() + self.upcoming();
      return val === 0 ? null : val;
    }, self);
  }
}
